<div *ngIf="noRecordsAddedOrUpdated">
    <div class="panel panel-info">No records updated or added, proceed to save updated Meeting details</div>    
</div>
<div class=""  [formGroup]="group" *ngIf="!noRecordsAddedOrUpdated || workersAddedOnly">
    <!-- <div class="contacts-roster" formArrayName="Roster">
        <div class="row" *ngFor="let w of  rosterArray.controls" [formGroup]="w">
            <span class="hidden">{{w.get("id").value}}</span>
            <div class="col-sm-1"> <input type="checkbox" formControlName="isSelected" /></div>
            <div class="col-sm-4">{{w.get("firstName").value}} {{w.get("middleName").value}} {{w.get("lastName").value}}
            </div>
            <div class="col-sm-3">{{w.get("email").value}}</div>
            <div class="col-sm-3">{{w.get("mobilePhone").value}}</div>
        </div> -->
    <div *ngIf="countOfMatched > 0">
        <div class="panel panel-info">There have been {{countOfMatched}} records selected for this meeting</div>    
        <mat-divider class="divider"></mat-divider>
    </div>
    <div *ngIf="alreadyRegisteredAttendeeIds.length > 0">
        <div class="panel panel-info">Some or all attendees are already registered for this meeting. Please continue to match the one(s) not registered yet.</div>    
        <mat-divider class="divider"></mat-divider>
    </div>
    <h3>Manual Record Match</h3>
    <div class="rosterlist panel panel-info" formArrayName="Roster">
        <div  class="row" *ngFor="let item of matchedRecords;let i = index" >     
            <div class="col-md-6 col-12 align-self-center">
                {{item.newRecord.get("firstName").value}} {{item.newRecord.get("lastName").value}} - {{item.newRecord.get("id").value}}
            </div>
            <div class="col-md-6 col-12">
                <mat-form-field [style.width.%]="100">
                <!-- <div class="panel">   -->
                    <mat-select matNativeControl class="form-control" (selectionChange)="SelectMatch($event,i)" [(value)]="selectedValue[i]" [disabled]="isAttendeeAlreadyRegistered(item)">
                        <mat-option value="" [id]="item.parentArrayIndex" >--No Match--</mat-option>
                        <mat-option  *ngFor="let match of item.matches;" [value]="match.id" [id]="match.recordLink">{{match.id}}  {{match.memberType}}  :  {{match.firstName}} {{match.lastName}}  | {{match.email}}  - Matched Score : {{match.matchedRanking}}</mat-option>
                    </mat-select>  
                <!-- </div> -->
                </mat-form-field>  
            </div>
        </div> 
    </div>
</div>
